import { StockFee } from "./types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FetchStateType, getFetchStateChange } from "../../models";

interface IStockFee {
  all?: StockFee[];
  searchTerm: string;
  displayData?: StockFee[];
  displayedStockFee?: StockFee;
  fetchState: FetchStateType;
}

const initialState: IStockFee = {
  searchTerm: "",
  fetchState: { type: "not-started" },
};

const name = "stockfees";

const stockFeesSlice = createSlice({
  name,
  initialState,
  reducers: {
    setStockFee: (state, action: PayloadAction<StockFee[] | undefined>) => ({
      ...state,
      all: action.payload,
      displayData: filterData(action.payload, state.searchTerm),
    }),
    setSearchTerm: (state, action: PayloadAction<string>) => ({
      ...state,
      searchTerm: action.payload.toLocaleLowerCase(),
      displayData: filterData(state.all, action.payload),
    }),
    setDisplayed: (state, action: PayloadAction<StockFee | undefined>) => ({
      ...state,
      displayedStockFee: action.payload,
    }),
    setFetchState: (state, action: PayloadAction<FetchStateType>) => ({
      ...state,
      displayedStockFee:
        action.payload.type === "successful"
          ? undefined
          : state.displayedStockFee,
      all: action.payload.type === "successful" ? undefined : state.all,
      displayData:
        action.payload.type === "successful" ? undefined : state.displayData,
      fetchState: getFetchStateChange(state.fetchState, action.payload),
    }),
  },
});

const filterData = (data?: StockFee[], searchTerm?: string) =>
  searchTerm === undefined || searchTerm === ""
    ? data
    : data?.filter(
        (e) =>
          e.startDate &&
          e.startDate
            .toString()
            .toLocaleLowerCase()
            .includes(searchTerm.toLocaleLowerCase().toLocaleLowerCase())
      );

export const {
  setStockFee,
  setSearchTerm,
  setDisplayed,
  setFetchState,
} = stockFeesSlice.actions;

export default stockFeesSlice.reducer;
